export const marqueeFlash = [
  "刚刚 · 某热播综艺官宣阵容，评论区秒破万",
  "20:42 · 顶流新剧路透曝光，造型引热议",
  "20:18 · 电竞战队官宣明星队长回归",
  "19:57 · 某音乐平台年度榜单一经上线即冲热搜",
  "19:31 · 新晋导演处女作豆瓣开分8.6",
  "19:02 · 品牌官宣全新代言人，深夜引爆话题",
  "18:44 · 热门动画电影点映口碑发酵",
  "18:20 · 某颁奖礼提名名单公布，网友吵翻了",
];

export const hotRank = [
  { rank: 1, title: "热播剧《晚风来信》大结局播出，全网催泪", tag: "剧集", heat: 986, up: true },
  { rank: 2, title: "新晋顶流男团回归舞台造型曝光", tag: "偶像", heat: 921, up: true },
  { rank: 3, title: "某悬疑剧演员阵容官宣，双影帝同台", tag: "剧集", heat: 887, up: true },
  { rank: 4, title: "音乐节官宣阵容，多个实力唱将加盟", tag: "音乐", heat: 843, hold: true },
  { rank: 5, title: "国民综艺新一季开启录制，飞行嘉宾路透", tag: "综艺", heat: 798, up: true },
  { rank: 6, title: "热门动画剧场版宣布暑期定档", tag: "动漫", heat: 762, down: true },
  { rank: 7, title: "年度颁奖礼红毯造型盘点出炉", tag: "时尚", heat: 714, up: true },
  { rank: 8, title: "爆款综艺幕后访谈特辑上线", tag: "综艺", heat: 668, hold: true },
  { rank: 9, title: "海外热播剧引进定档，粉丝翘首以盼", tag: "剧集", heat: 621, up: true },
  { rank: 10, title: "新晋歌手首张专辑突破白金销量", tag: "音乐", heat: 573, down: true },
];

export const newsList = [
  {
    id: 1,
    cat: "剧集",
    title: "《晚风来信》大结局：开放式结尾引发全网讨论",
    summary: "热播都市剧迎来大结局，开放式结尾让观众各执一词，主演也发文分享拍摄心得，相关话题持续霸榜热搜。",
    time: "20:38",
    tag: "热",
    img: "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20city%20night%20scene%20with%20warm%20amber%20streetlight%20and%20two%20silhouetted%20figures%20under%20soft%20glow%2C%20dreamy%20atmospheric%20lighting%2C%20warm%20muted%20tone%2C%20artistic%20poster%20style&width=800&height=560&seq=melon-news-01&orientation=landscape",
  },
  {
    id: 2,
    cat: "综艺",
    title: "爆款户外综艺新一季回归，首期录制亮点提前曝",
    summary: "国民户外综艺宣布新一季开录，飞行嘉宾阵容引发期待，官方抢先放出概念海报与花絮片段。",
    time: "20:05",
    tag: "热",
    img: "https://readdy.ai/api/search-image?query=Colorful%20playful%20variety%20show%20stage%20with%20confetti%20and%20bright%20vibrant%20decorations%2C%20warm%20sunlight%2C%20energetic%20youthful%20atmosphere%2C%20stylized%20illustration&width=800&height=560&seq=melon-news-02&orientation=landscape",
  },
  {
    id: 3,
    cat: "音乐",
    title: "年度音乐榜单揭晓，多首黑马单曲杀出重围",
    summary: "年度音乐榜单正式揭晓，除了老牌歌手持续领跑，不少独立音乐人的新作也凭借口碑强势上榜。",
    time: "19:41",
    tag: "新",
    img: "https://readdy.ai/api/search-image?query=Golden%20stage%20spotlight%20with%20microphone%20and%20floating%20music%20notes%2C%20warm%20golden%20glow%2C%20elegant%20concert%20atmosphere%2C%20stylized%20poster%20art&width=800&height=560&seq=melon-news-03&orientation=landscape",
  },
  {
    id: 4,
    cat: "偶像",
    title: "新晋男团周年见面会官宣，全开麦舞台成热议",
    summary: "人气男团宣布周年纪念见面会，彩排花絮释出，全员真唱舞台表现获得乐迷一致好评。",
    time: "19:16",
    tag: "新",
    img: "https://readdy.ai/api/search-image?query=Youthful%20kpop%20boy%20band%20on%20stage%20with%20neon%20coral%20and%20teal%20lights%2C%20dynamic%20concert%20silhouette%2C%20energetic%20fans%20atmosphere%2C%20stylized%20artwork&width=800&height=560&seq=melon-news-04&orientation=landscape",
  },
  {
    id: 5,
    cat: "动漫",
    title: "热门动画剧场版定档暑期，首支预告口碑发酵",
    summary: "国民级动画IP推出全新剧场版并宣布暑期档上映，首支预告上线后凭借精良画面引发期待。",
    time: "18:52",
    tag: "热",
    img: "https://readdy.ai/api/search-image?query=Anime%20movie%20theatrical%20poster%20with%20adventure%20skyline%20and%20warm%20sunset%20glow%2C%20stylized%202D%20animation%20background%2C%20epic%20journey%20mood&width=800&height=560&seq=melon-news-05&orientation=landscape",
  },
  {
    id: 6,
    cat: "时尚",
    title: "颁奖礼红毯造型盘点：高定礼服与新锐设计师同框",
    summary: "年度颁奖礼红毯亮相，多位明星身着本土高定与先锋设计师作品，时尚媒体连夜盘点评分。",
    time: "18:27",
    tag: "新",
    img: "https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20evening%20gown%20detail%20with%20warm%20spotlight%20and%20flowing%20fabric%2C%20luxurious%20fashion%20editorial%20photo%2C%20soft%20bokeh%20background&width=800&height=560&seq=melon-news-06&orientation=landscape",
  },
];

export const cats = [
  { name: "剧集瓜", icon: "ri-clapperboard-line", color: "text-primary-600 bg-primary-100", desc: "新剧定档、演员阵容、剧情走向" },
  { name: "综艺瓜", icon: "ri-vidicon-line", color: "text-accent-600 bg-accent-100", desc: "节目官宣、嘉宾路透、录制爆料" },
  { name: "偶像瓜", icon: "ri-star-smile-line", color: "text-secondary-600 bg-secondary-100", desc: "回归舞台、活动同框、专辑动态" },
  { name: "音乐瓜", icon: "ri-music-2-line", color: "text-primary-600 bg-primary-100", desc: "新歌首发、榜单盘点、演唱会讯息" },
  { name: "动漫瓜", icon: "ri-movie-2-line", color: "text-accent-600 bg-accent-100", desc: "剧场版定档、动画新作、声优动态" },
  { name: "时尚瓜", icon: "ri-shirt-line", color: "text-secondary-600 bg-secondary-100", desc: "红毯造型、代言官宣、高定动向" },
];

export const features = [
  {
    cat: "专题",
    title: "爆款剧《晚风来信》凭什么刷屏？幕后剧组与观众都在聊什么",
    img: "https://readdy.ai/api/search-image?query=Warm%20cinematic%20behind%20the%20scenes%20film%20set%20with%20director%20chair%20and%20soft%20studio%20lights%2C%20creative%20workspace%2C%20amber%20mood%20lighting%2C%20stylized%20editorial%20photo&width=1200&height=760&seq=melon-feature-01&orientation=landscape",
    excerpt: "从阵容官宣到口碑爆发，这部都市剧如何精准击中当代观众的共情点？我们梳理了热度发酵的完整时间线。",
  },
  {
    cat: "深读",
    title: "全开麦、唱跳、真唱：舞台现场为什么成了今年的关键词",
    img: "https://readdy.ai/api/search-image?query=Dynamic%20live%20concert%20crowd%20silhouette%20with%20golden%20stage%20beams%20and%20confetti%2C%20passionate%20atmosphere%2C%20warm%20tone%2C%20stylized%20music%20editorial&width=1200&height=760&seq=melon-feature-02&orientation=landscape",
    excerpt: "当现场感成为衡量舞台的重要标尺，偶像产业正在发生怎样的变化？这篇深读拆解趋势背后的行业逻辑。",
  },
];

export const faqs = [
  {
    q: "今天吃瓜的信息为什么更新这么快？",
    a: "我们整合了公开渠道的海量线索，由编辑部实时筛选、交叉核验后第一时间发布，并持续滚动刷新今日更新内容，确保你看到的都是新鲜且经过甄别的一手消息。",
  },
  {
    q: "平台上的爆料都可信吗？",
    a: "所有动态都会标注信息来源与状态。对于尚未证实的内容，我们会明确提示“待核实”，并持续跟进后续进展，避免未经核实的消息被误当事实传播。",
  },
  {
    q: "如何及时收到最新瓜料推送？",
    a: "你可以订阅本站的邮箱提醒，热门动态与今日重点更新会第一时间推送到你的邮箱；也可通过站内搜索按关键词追踪你关心的实时动态。",
  },
  {
    q: "我有独家消息或线索想投稿怎么办？",
    a: "欢迎通过页尾的投稿表单与我们联系。请在描述中写明线索要点与可核实的佐证，编辑部审核通过后会优先跟进，并对信息来源保密。",
  },
];

export const testimonials = [
  { name: "小林同学", role: "剧迷", text: "追剧实时动态真的香，大结局上热搜前我就在站里看到讨论了，抢到了前排！", star: 5 },
  { name: "阿泽", role: "综艺观众", text: "红毯造型盘点整理得很全，图也好看，基本成了我每周必刷的栏目。", star: 5 },
  { name: "Melody", role: "音乐发烧友", text: "新歌和榜单更新得很及时，还能顺着链接去听完整版，体验很顺滑。", star: 4 },
];

export const columns = ["剧集瓜", "综艺瓜", "偶像瓜", "音乐瓜", "动漫瓜", "时尚瓜"];
export const aboutLinks = ["关于我们", "投稿指南", "常见问题", "内容原则"];